/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 353c4e96af29edaed3649d629582d463962d0c14cba40b3ba22737659d8f46de */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBoards: build.query<GetBoardsApiResponse, GetBoardsApiArg>({
      query: (queryArg) => ({
        url: `/boards/Boards`,
        params: {
          clientNo: queryArg.clientNo,
          clientId: queryArg.clientId,
        },
      }),
    }),
    getBoardsByGroupId: build.query<
      GetBoardsByGroupIdApiResponse,
      GetBoardsByGroupIdApiArg
    >({
      query: (queryArg) => ({ url: `/boards/Boards/${queryArg.groupId}` }),
    }),
    getBoardsByIdMembers: build.query<
      GetBoardsByIdMembersApiResponse,
      GetBoardsByIdMembersApiArg
    >({
      query: (queryArg) => ({ url: `/boards/Boards/${queryArg.id}/members` }),
    }),
    getBoardsByIdAnnualcycle: build.query<
      GetBoardsByIdAnnualcycleApiResponse,
      GetBoardsByIdAnnualcycleApiArg
    >({
      query: (queryArg) => ({
        url: `/boards/Boards/${queryArg.id}/annualcycle`,
        params: {
          year: queryArg.year,
        },
      }),
    }),
    putBoardsByGroupIdAssignmentAndAssignmentIdResponsibility: build.mutation<
      PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiResponse,
      PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/boards/Boards/${queryArg.groupId}/assignment/${queryArg.assignmentId}/responsibility`,
        method: 'PUT',
        body: queryArg.selectiongroupResponsibilityUpdateModel,
      }),
    }),
    getBoardsByClientIdBoardmembers: build.query<
      GetBoardsByClientIdBoardmembersApiResponse,
      GetBoardsByClientIdBoardmembersApiArg
    >({
      query: (queryArg) => ({
        url: `/boards/Boards/${queryArg.clientId ?? ':clientId'}/boardmembers`,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as board }
export type GetBoardsApiResponse =
  /** status 200 OK */ SelectionGroupReturnModel[]
export type GetBoardsApiArg = {
  /** ClientNo */
  clientNo?: number
  /** ClientId */
  clientId?: string
}
export type GetBoardsByGroupIdApiResponse =
  /** status 200 OK */ SelectionGroupReturnModel
export type GetBoardsByGroupIdApiArg = {
  /** Board id */
  groupId: string
}
export type GetBoardsByIdMembersApiResponse =
  /** status 200 OK */ SelectionGroupMemberReturnModel[]
export type GetBoardsByIdMembersApiArg = {
  /** Board id */
  id: string
}
export type GetBoardsByIdAnnualcycleApiResponse =
  /** status 200 OK */ AnnualCycleModel
export type GetBoardsByIdAnnualcycleApiArg = {
  /** Board Id */
  id: string
  /** Year */
  year?: number
}
export type PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiResponse =
  unknown
export type PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiArg = {
  groupId: string
  assignmentId: number
  selectiongroupResponsibilityUpdateModel: SelectiongroupResponsibilityUpdateModel
}
export type GetBoardsByClientIdBoardmembersApiResponse =
  /** status 200 OK */ SelectionGroupMemberReturnModel[]
export type GetBoardsByClientIdBoardmembersApiArg = {
  /** Client id */
  clientId?: string
}
export type SelectionGroupAddress = {
  line1?: string | null
  line2?: string | null
  line3?: string | null
  zip?: string | null
  city?: string | null
}
export type SelectionGroupReturnModel = {
  id?: string | null
  name?: string | null
  mail?: string | null
  terminates?: string | null
  clientId?: string | null
  clientNo?: number
  created?: string | null
  officeAddress?: SelectionGroupAddress
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type SelectionGroupPersonModel = {
  id?: string | null
  nameNo?: number | null
  firstname?: string | null
  surname?: string | null
  gender?: Gender
  address?: SelectionGroupAddress
  mobile?: string | null
  email?: string | null
  showPhoneNumber?: boolean
  showEmail?: boolean
  lastUpdated?: string
  reservedAgainstElCommunication?: boolean
}
export type SelectionGroupMemberReturnModel = {
  id?: number
  nameNo?: number
  person?: SelectionGroupPersonModel
  clientNo?: number
  clientId?: string | null
  memberFrom?: string
  memberTo?: string | null
  memberFunction?: string | null
  memberFunctionId?: number
  chairman?: boolean
  deputy?: boolean
  boardMember?: boolean
  alternateMember?: boolean
  associatedGeneralManager?: boolean
  notPortal?: boolean
  active?: boolean
  yearsSelected?: number | null
  sortOrder?: string | null
  secretary?: boolean
  bblRepresentative?: boolean
  accountant?: boolean
  memberNominationBoard?: boolean
  clientContact?: boolean
  responsibility?: string | null
  assignmentId?: number
}
export type AnnualCycleTaskModel = {
  /** Id of the task
    <i>Id på oppgaven</i> */
  id?: string | null
  /** Title of the task
    <i>Oppgavens tittel</i> */
  title?: string | null
  /** Description of the task
    <i>Beskrivelse av oppgave</i> */
  description?: string | null
  /** Deadline of the task
    <i>Frist for utførelse av oppgave</i> */
  deadline?: string
  /** Frequency in months
    <i>Oppgavens frekvens</i> */
  frequencyInMonths?: number
  /** Task is visible to residents
    <i>Oppgave synlig for beboere</i> */
  visibleForResidents?: boolean
  /** NameRegistry Id of user that created this task
    <i>NavneregisterId til bruker som opprettet oppgaven</i> */
  createdBy?: string | null
}
export type AnnualCycleModel = {
  /** List of tasks for the cycle
    <i>Liste med oppgaver for året</i> */
  tasks?: AnnualCycleTaskModel[] | null
}
export type SelectiongroupResponsibilityUpdateModel = {
  responsibility?: string | null
}
export enum Gender {
  Unknown = 'Unknown',
  Female = 'Female',
  Male = 'Male',
  Juridisk = 'Juridisk',
}
export const {
  useGetBoardsQuery,
  useGetBoardsByGroupIdQuery,
  useGetBoardsByIdMembersQuery,
  useGetBoardsByIdAnnualcycleQuery,
  usePutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityMutation,
  useGetBoardsByClientIdBoardmembersQuery,
} = injectedRtkApi
